import { cn } from '@/lib/utils'
import { GameIcon } from '@/shared/ui/GameIcon'

export interface LevelPlayStartRewardsProps {
  pointReward?: number | null
  coinReward?: number | null
  className?: string
}

const hasReward = (value?: number | null) => (value ?? 0) > 0

/**
 * Footer de recompensas do card de abertura de jornada — duas colunas com
 * rótulos "Recompensa" e "Bônus", como no handoff Level Play.
 * Omitido quando experiência e moedas são nulas ou zero.
 */
export const LevelPlayStartRewards = ({
  pointReward,
  coinReward,
  className
}: LevelPlayStartRewardsProps) => {
  const showPoints = hasReward(pointReward)
  const showCoins = hasReward(coinReward)

  if (!showPoints && !showCoins) return null

  return (
    <div
      className={cn(
        'flex gap-3 border-t border-gray-200 pt-3',
        showPoints && showCoins ? 'justify-between' : 'justify-center',
        className
      )}
    >
      {showPoints && (
        <div className="flex min-w-0 flex-col items-center gap-1">
          <span className="text-caps font-bold uppercase tracking-wide text-gray-700">
            Recompensa
          </span>
          <span className="flex items-center gap-1 text-sm font-bold text-gray-900">
            <GameIcon name="star" size={14} aria-hidden />
            {pointReward} XP
          </span>
        </div>
      )}
      {showCoins && (
        <div className="flex min-w-0 flex-col items-center gap-1">
          <span className="text-caps font-bold uppercase tracking-wide text-gray-700">
            Bônus
          </span>
          <span className="flex items-center gap-1 text-sm font-bold text-gray-900">
            <GameIcon name="coins" size={14} aria-hidden />
            {coinReward} moedas
          </span>
        </div>
      )}
    </div>
  )
}
